import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api';

interface GeologyResponse {
  unit_code: string | null;
  unit_name: string | null;
  rock_group: string | null;
  strat_age: string | null;
  strat_name: string | null;
}

export function useGeologyQuery(bbox: [number, number, number, number] | null) {
  return useQuery<GeologyResponse>({
    queryKey: ['geology', bbox],
    queryFn: async () => {
      if (!bbox) throw new Error('No bbox provided');
      const { data } = await apiClient.post('/geology/query', {
        min_lng: bbox[0],
        min_lat: bbox[1],
        max_lng: bbox[2],
        max_lat: bbox[3],
      });
      return data;
    },
    enabled: !!bbox,
    staleTime: 0, // Always refetch when bbox changes; backend caches for 7d
    retry: 2,
  });
}
